import AuthProvider, { useAuth } from './AuthProvider';
import LoginPage from './LoginPage';

function AuthGate({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[var(--surface-page)] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-cgiar-green border-t-transparent rounded-full animate-spin" />
          <p className="text-[var(--text-secondary)]">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return children;
}

export default function ProtectedApp({ children }) {
  // Skip auth when VITE_SKIP_AUTH is set (e.g. in .env.development.local)
  if (import.meta.env.VITE_SKIP_AUTH === 'true') return children;

  // Wrap with AuthProvider, show LoginPage if not authenticated
  return (
    <AuthProvider>
      <AuthGate>{children}</AuthGate>
    </AuthProvider>
  );
}
